import React, { ReactElement } from 'react'
import styles from './ValueProposition.module.scss'
import { reusableCssClass } from '@/utils/reusableCssClasses'
import { LinkItem } from '@/components/static/ui/LinkItem/LinkItem'

interface ValuePropositionProps {
    title: string
    description: string
    image: ReactElement
    titleFontColors: { desktop: string; mobile: string }
    isMobileMode: boolean
    backgroundColors: { desktop: string; mobile: string }
    // Optional "read more" beneath the description. Blocks that describe a
    // feature with its own page should send interested readers there.
    link?: { href: string; text: string }
    // Optional mark shown beside the title, e.g. the Eupheus owl.
    titleImageSrc?: string
}

export const ValueProposition: React.FC<ValuePropositionProps> = (
    props
): ReactElement => {
    return (
        <div
            className={`${styles.baseValueProposition} ${reusableCssClass.centerChildrenVertically}`}
            style={{
                background: props.isMobileMode
                    ? props.backgroundColors.mobile
                    : props.backgroundColors.desktop,
            }}
        >
            <div
                className={styles.title}
                style={{
                    color: props.isMobileMode
                        ? props.titleFontColors.mobile
                        : props.titleFontColors.desktop,
                }}
            >
                {props.titleImageSrc && (
                    /* eslint-disable-next-line @next/next/no-img-element */
                    <img
                        className={styles.titleImage}
                        src={props.titleImageSrc}
                        alt={''}
                        draggable={false}
                    />
                )}
                <span>{props.title}</span>
            </div>
            <div className={styles.description}>{props.description}</div>
            {props.link && (
                <div className={styles.link}>
                    <LinkItem href={{ pathname: props.link.href }}>
                        {props.link.text}
                    </LinkItem>
                </div>
            )}
            <div className={styles.imageContainer}>{props.image}</div>
        </div>
    )
}
